import { createContext, useContext } from 'react';

export type TransitioningContext = {
  transitioning: boolean;
  setTransitioning: (transitioning: boolean) => void;
  disabled: boolean;
  setDisabled: (disabled: boolean) => void;
};

export const TransitioningContext = createContext<TransitioningContext>({
  transitioning: false,
  setTransitioning: () => {},
  disabled: false,
  setDisabled: () => {},
});
export const useTransitioningCtxState = () => {
  const { transitioning, disabled } = useContext(TransitioningContext);
  return { transitioning, disabled };
};
